
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ApiFormService, Validators } from '@personal-area/global/form-validation/services';
import { ErrorTexts } from '@personal-area/global/form-validation/models';
import { FormFieldComponent } from '@personal-area/global/ui'
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@personal-area/global/accounts/services';
import { finalize } from 'rxjs/operators';

interface DialogData {
  accountId: number;
  userId: number;
  name: string;
}

@Component({
    selector: 'app-rename-account-popup',
    templateUrl: './rename-account-popup.component.html',
    styleUrls: ['./rename-account-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    FormFieldComponent
],
    providers: [
        AccountService,
    ]
})
export class RenameAccountPopupComponent implements OnInit {
  public form: UntypedFormGroup;
  public error: string;
  public maxLength = 40;

  public submitErrors: EventEmitter<void>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: DialogData,
    public dialogRef: MatDialogRef<RenameAccountPopupComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _formService: ApiFormService,
    private _accountService: AccountService,
  ) {
    this.submitErrors = new EventEmitter<void>();
  }

  public fieldErrors(field: string): ErrorTexts {
    return {
      required: `account-popup.error.${field}-required`,
      maxlength: `account-popup.error.${field}-invalid`,
    };
  }

  ngOnInit() {
    this.form = this._formBuilder.group({
      name: [
        this._data.name || '',
        [Validators.required, Validators.maxLength(this.maxLength)],
      ],
    });
  }

  formSubmit() {
    if (this.form.valid) {
      const name = this.form.value.name.replace(/^\s+/g, '').trim();
      this.form.disable();
      this._accountService
        .changeName(this._data.userId, this._data.accountId, name)
        .pipe(finalize(() => this.form.enable()))
        .subscribe(
          () => {
            this.dialogRef.close(name);
          },
          (err) => {
            this._formService.defaultFormError(err, this.form);
            this.submitErrors.next();
          },
        );
    } else {
      this.submitErrors.next();
    }
  }
}
